<template>
    <!-- .stop nutne - EnvironmentPill.vue vykresluje tenhle popup jako
         potomka sveho vlastniho klikaciho wrapperu; bez .stop by klik na
         backdrop probublal a wrapper by popup hned zase otevrel. -->
    <div class="env-effects-popup-overlay" @click.self.stop="$emit('close')">
        <div class="env-effects-popup-box">
            <div class="env-effects-popup-title">{{ environment ? environment.name : $t('journey.environmentEffects.normalBattlefield') }}</div>
            <div class="env-effects-popup-current">{{ environment ? environment.text : $t('journey.environmentEffects.noSpecialConditions') }}</div>

            <div class="env-effects-popup-divider" />
            <div class="env-effects-popup-label">{{ $t('journey.environmentEffects.possibleEffectsLabel') }}</div>
            <div
                v-for="rule in ruleCatalog"
                :key="rule.label"
                class="env-effects-popup-rule"
                :class="{'env-effects-popup-rule--active': isActive(rule)}"
            >
                <v-icon size="20" class="mr-2" color="white">{{ rule.icon }}</v-icon>
                <div class="env-effects-popup-rule-text">
                    <div class="env-effects-popup-rule-label">{{ rule.label }}<span v-if="isActive(rule)" class="env-effects-popup-rule-active-tag">{{ $t('journey.environmentEffects.activeNowTag') }}</span></div>
                    <div class="env-effects-popup-rule-desc">{{ rule.desc }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// Jmena jako "Magic day" jsou nahodne priradene "flavor" nazvy - realne
// existuji jen tyhle 3 mechaniky (FightEnvironmentService.php rules), ne
// samostatny katalog desitek unikatnich efektu.
const RULE_CATALOG_META = [
    {key: 'pokemonBonus', rules: [1], icon: 'mdi-paw'},
    {key: 'attackBonus', rules: [2], icon: 'mdi-sword-cross'},
    {key: 'levelTerrain', rules: [3, 4], icon: 'mdi-terrain'},
];

export default {
    name: 'EnvironmentEffectsPopup',
    props: {
        // null = zadne prostredi (normal battlefield)
        environment: {type: Object, default: null},
    },
    computed: {
        ruleCatalog() {
            return RULE_CATALOG_META.map((meta) => ({
                ...meta,
                label: this.$t('journey.environmentEffects.rule.' + meta.key + '.label'),
                desc: this.$t('journey.environmentEffects.rule.' + meta.key + '.desc'),
            }));
        },
    },
    methods: {
        isActive(rule) {
            return !!this.environment && rule.rules.includes(this.environment.rule);
        },
    },
}
</script>

<style scoped>
/* Stejny recept jako OakSkillHintPopup.vue (tmavy poloprusvitny ramecek). */
.env-effects-popup-overlay {
    position: fixed;
    inset: 0;
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    background: rgba(0, 0, 0, .35);
    cursor: pointer;
}
.env-effects-popup-box {
    max-width: min(90vw, 420px);
    width: 100%;
    max-height: 80vh;
    overflow-y: auto;
    background: rgba(0, 0, 0, .85);
    backdrop-filter: blur(2px);
    color: #fff;
    padding: 18px 20px;
    border-radius: 12px;
    box-shadow: 0 8px 24px rgba(0, 0, 0, .4);
    cursor: default;
    white-space: normal;
}
.env-effects-popup-title {
    font-weight: 700;
    font-size: 1.15em;
}
.env-effects-popup-current {
    margin-top: 6px;
    font-size: 0.95em;
    opacity: 0.9;
}
.env-effects-popup-divider {
    margin: 14px 0 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.2);
}
.env-effects-popup-label {
    font-size: 0.75em;
    font-weight: 700;
    letter-spacing: 0.04em;
    opacity: 0.65;
    text-transform: uppercase;
    margin-bottom: 8px;
}
.env-effects-popup-rule {
    display: flex;
    align-items: flex-start;
    gap: 4px;
    padding: 8px;
    border-radius: 8px;
    margin-bottom: 6px;
}
/* secondary theme barva (#21A87A) rozepsana jako RGB triplet - rgba()
   nejde kombinovat s var(), vuetify.js negeneruje -rgb variantu promenne. */
.env-effects-popup-rule--active {
    background: rgba(33, 168, 122, 0.25);
    box-shadow: inset 0 0 0 1px rgba(33, 168, 122, 0.6);
}
.env-effects-popup-rule-text {
    min-width: 0;
}
.env-effects-popup-rule-label {
    font-weight: 700;
    font-size: 0.95em;
}
.env-effects-popup-rule-active-tag {
    display: inline-block;
    margin-left: 6px;
    padding: 1px 6px;
    border-radius: 8px;
    background: var(--v-secondary-base, #21A87A);
    color: #fff;
    font-size: 0.68em;
    font-weight: 800;
    letter-spacing: 0.03em;
    vertical-align: middle;
}
.env-effects-popup-rule-desc {
    font-size: 0.85em;
    opacity: 0.8;
    margin-top: 1px;
}
</style>
